
export default {
  props: {
    items: {
      type: Array,
      required: false,
      default() {
        return null;
      },
    },

    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    getChildsLength(category) {
      return Array.isArray(category.items)
        ? category.items.length
        : category.items;
    },
  },
};
